import { useId } from 'react';

type Lane = { avatar: string; letter: string; items: ({ kind: 'block'; color: string } | { kind: 'gap' })[] };

/** Szerokości w godzinach – suma 8 na tor (oś 9:00–17:00). */
const LANES: { lane: Lane; spans: number[] }[] = [
  {
    lane: { avatar: 'var(--mantine-color-brand-6)', letter: 'A', items: [{ kind: 'gap' }, { kind: 'block', color: '#7950f2' }, { kind: 'gap' }, { kind: 'block', color: '#12b886' }] },
    spans: [1, 2.5, 2, 2.5],
  },
  {
    lane: { avatar: 'var(--mantine-color-orange-6)', letter: 'K', items: [{ kind: 'block', color: '#fd7e14' }, { kind: 'block', color: '#228be6' }, { kind: 'gap' }] },
    spans: [2, 2.5, 3.5],
  },
  {
    lane: { avatar: 'var(--mantine-color-orange-6)', letter: 'O', items: [{ kind: 'gap' }, { kind: 'block', color: '#40c057' }, { kind: 'block', color: '#e64980' }, { kind: 'gap' }] },
    spans: [1.5, 3, 2, 1.5],
  },
];

const X0 = 30;
const HOUR = 26;
const LANE_H = 30;
const TOP = 14;

/**
 * Miniatura „Planu dnia” do zachęty nad listą: tory osób z zajęciami w kolorach typów, kreskowane wolne okna
 * i kreska „teraz” – w tym samym stylu co prawdziwa oś (`FamilyTimeline`). Ozdobna, czytnik ekranu ją pomija.
 */
export function TimelinePreview() {
  const hatch = `hatch-${useId().replace(/:/g, '')}`;
  const width = X0 + 8 * HOUR + 2;
  const height = TOP + LANES.length * LANE_H;
  return (
    <svg viewBox={`0 0 ${width} ${height}`} width={width} height={height} aria-hidden="true" style={{ maxWidth: '100%', height: 'auto', flex: 'none' }}>
      <defs>
        <pattern id={hatch} width="8" height="8" patternUnits="userSpaceOnUse" patternTransform="rotate(45)">
          <rect width="8" height="8" fill="var(--mantine-color-white)" />
          <rect width="4" height="8" fill="var(--mantine-color-brand-0)" />
        </pattern>
      </defs>
      {/* Godziny */}
      {Array.from({ length: 9 }, (_, h) => (
        <g key={h}>
          <line x1={X0 + h * HOUR} x2={X0 + h * HOUR} y1={TOP - 2} y2={height} stroke="var(--mantine-color-gray-3)" strokeWidth="1" />
          {h % 2 === 0 ? (
            <text x={X0 + h * HOUR} y={TOP - 5} fontSize="8" textAnchor="middle" fill="var(--mantine-color-gray-6)">
              {9 + h}
            </text>
          ) : null}
        </g>
      ))}
      {LANES.map(({ lane, spans }, row) => {
        const y = TOP + row * LANE_H + 4;
        const h = LANE_H - 8;
        let x = X0;
        return (
          <g key={row}>
            <circle cx={12} cy={y + h / 2} r={10} fill={lane.avatar} />
            <text x={12} y={y + h / 2 + 3.5} fontSize="10" fontWeight="700" textAnchor="middle" fill="var(--mantine-color-white)">
              {lane.letter}
            </text>
            {lane.items.map((item, i) => {
              const w = spans[i]! * HOUR;
              const left = x + 1.5;
              x += w;
              return item.kind === 'block' ? (
                <g key={i}>
                  <rect x={left} y={y} width={w - 3} height={h} rx="5" fill={item.color} fillOpacity="0.2" />
                  <rect x={left} y={y} width="4" height={h} rx="2" fill={item.color} />
                  <rect x={left + 9} y={y + h / 2 - 2} width={Math.max(8, w - 24)} height="4" rx="2" fill={item.color} fillOpacity="0.55" />
                </g>
              ) : (
                <rect key={i} x={left} y={y} width={w - 3} height={h} rx="5" fill={`url(#${hatch})`} stroke="var(--mantine-color-brand-3)" strokeWidth="1.2" strokeDasharray="3 2" />
              );
            })}
          </g>
        );
      })}
      {/* Teraz */}
      <line x1={X0 + 3.2 * HOUR} x2={X0 + 3.2 * HOUR} y1={TOP} y2={height} stroke="var(--mantine-color-red-6)" strokeWidth="2" />
    </svg>
  );
}
